module.exports = __webpack_public_path__ + "static/media/6.f0954789.jpg";